import {Component, effect, OnInit} from '@angular/core';
import {environment} from '@environments/environment';
import {UntypedFormControl, UntypedFormGroup, Validators, ReactiveFormsModule} from '@angular/forms';
import {AppAuthService} from '@services/core/auth/app-auth.service';
import {TenantService} from '@services/core/tenant/tenant.service';
import {AuthService} from "@app/areas/auth/services/auth.service";
import {take} from "rxjs/operators";
import {LocalizeTextPipe} from '@shared/pipes/localize-text/localize-text.pipe';
import {IconComponent} from '../../shared/components/icon/icon.component';
import {ButtonComponent} from '../../shared/components/buttons/button/button.component';
import {FormControlErrorDirective} from '../../shared/directives/form-control-error/form-control-error.directive';
import {FitmedLogoWhiteComponent} from '../../shared/components/fitmed-logo-white/fitmed-logo-white.component';
import {hasValue} from "@shared/utils/helpers";
import {Router} from "@angular/router";

@Component({
  selector: 'app-account-login',
  templateUrl: './account-login.component.html',
  styleUrls: ['./account-login.component.scss'],
  standalone: true,
  imports: [FitmedLogoWhiteComponent, ReactiveFormsModule, FormControlErrorDirective, ButtonComponent, IconComponent, LocalizeTextPipe]
})
export class AccountLoginComponent implements OnInit {
  loginForm = new UntypedFormGroup({
    username: new UntypedFormControl(
      environment.production ? '' : 'rob@fitmed.com',
      [Validators.required]
    ),
    password: new UntypedFormControl(environment.production ? '' : 'Kachow@123!', [
      Validators.required,
    ]),
  });

  loadingLogin$ = false;

  constructor(
    private appAuthService: AppAuthService,
    private tenantService: TenantService,
    private authService: AuthService,
    private router: Router,
  ) {
    this.tenantService.clear();

    effect(() => {
      const user = this.appAuthService.user$();
      console.log('user', user)
      if (hasValue(user)) {
        this.router.navigate(['/cn'])
      }
    })

    effect(() => {
      const at = this.authService.accessToken$();
      console.log('access token changed, refreshing user...')
      if (hasValue(at)) {
        this.appAuthService.refreshUserPractitionerData()
      }
    });
  }

  ngOnInit(): void {
  }

  login(): void {
    this.loadingLogin$ = true;
    const formData = this.loginForm.getRawValue();

    this.authService.login(formData.username, formData.password)
      .pipe(take(1))
      .subscribe({
        next: res => {
          this.loadingLogin$ = false
        },
        error: err => {
          this.loadingLogin$ = false
        }
      })
  }
}
